export const InvitationStatus = {
    enviada: 1,
    aguardando_anunciante: 2,
    aguardando_roommate: 3,
    aceita_anunciante: 4,
    aceita_roommate: 5,
    negada_anunciante: 6,
    negada_roommate: 7,
    expirado: 8
};
